import React from 'react';
import './Chapters.scss';

function Chapter1() {
  return (
    <section className="chapter">
      <p className="chapter-paragraph">
        For more than a century, there were typically three ways to treat cancer: remove it
        surgically, destroy it with radiation, or reduce it with chemotherapy. While these methods
        remain essential tools in the cancer-fighting arsenal, they may not work for everyone or can
        stop working over time. But with the discovery of immunotherapy, an innovation that
        harnesses the body’s immune system to target and attack cancer cells, the world of treating
        certain cancers that no longer respond to treatment became a much more promising place.
      </p>
      <p className="chapter-paragraph">
        One type of advanced immunotherapy—known as autologous{' '}
        <span className="italic">chimeric antigen receptor</span> (CAR) T-cell therapy, or
        autologous <span className="italic">CAR T</span>—was first approved by the U.S. Food and
        Drug Administration (FDA) in 2017 for the treatment of leukemia that no longer responded to
        available treatments. Since then, CAR T has fundamentally changed how some aggressive
        cancers are treated. Following initial FDA approval, additional autologous CAR T therapies
        were approved, including for a growing number of blood cancers such as lymphoma and myeloma.
      </p>
      <p className="chapter-paragraph">
        Yet as this excitement around CAR T escalated, so did a growing problem that impacts
        healthcare providers and thousands of patients: limited access to treatment. The solution
        may lie in the next generation of products—allogeneic CAR T.
      </p>
    </section>
  );
}

export default Chapter1;
